import { Outlet, ScrollRestoration, useLocation } from 'react-router-dom';

import { DocumentTitle } from '@/app/router/DocumentTitle';
import { ErrorBoundary } from '@/components/shared/ErrorBoundary';
import { SkipToContent } from '@/components/shared/SkipToContent';

/**
 * Outermost layout, shared by every route.
 *
 * Holds the concerns that must exist on all pages: the skip link, scroll
 * restoration across navigations, and a route-scoped error boundary keyed to
 * the pathname so navigating away from a crashed page clears the error.
 */
export function RootLayout() {
  const location = useLocation();

  return (
    <>
      <DocumentTitle />
      <SkipToContent />
      <ScrollRestoration />
      <ErrorBoundary resetKeys={[location.pathname]}>
        <Outlet />
      </ErrorBoundary>
    </>
  );
}
